/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_Discount_HintInputs */

const en_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a discount or create a custom one`)
};

const de_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle einen Rabatt oder erstelle einen benutzerdefinierten`)
};

const es_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un descuento o crea uno personalizado`)
};

const fr_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez une remise ou créez-en une personnalisée`)
};

const it_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona uno sconto o creane uno personalizzato`)
};

const pt_br2_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um desconto ou crie um personalizado`)
};

const pl_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz zniżkę lub utwórz niestandardową`)
};

const hu_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válasszon kedvezményt vagy hozzon létre egyénit`)
};

const ro_admin_plan_discount_form_discount_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectati o reducere sau creati una personalizata`)
};

/**
* | output |
* | --- |
* | "Select a discount or create a custom one" |
*
* @param {Admin_Plan_Discount_Form_Discount_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_discount_hint = /** @type {((inputs?: Admin_Plan_Discount_Form_Discount_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_Discount_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_discount_hint(inputs)
	if (locale === "de") return de_admin_plan_discount_form_discount_hint(inputs)
	if (locale === "es") return es_admin_plan_discount_form_discount_hint(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_discount_hint(inputs)
	if (locale === "it") return it_admin_plan_discount_form_discount_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_discount_hint(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_discount_hint(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_discount_hint(inputs)
	return ro_admin_plan_discount_form_discount_hint(inputs)
});
export { admin_plan_discount_form_discount_hint as "admin.plan_discount_form.discount_hint" }